// extracted by mini-css-extract-plugin
export default {"modal":"K79BWM","jsonEditorWrapper":"n0qiCr","footer":"Qh8twl","validBorder":"EsL4GE","animation-valid-border":"pAAgr4","animationValidBorder":"pAAgr4"};